<!-- Zweck: Stellt die HTML-Struktur für shop artikel aktionen details component im Frontend bereit. -->
@if ((msvc.isMobile()|async)) {
  <table class="table table-body-striped noborders" style="width: 100%">
    @for (aktion of aktionen?.aktionen; track aktion) {
      <tbody>
        @if (showActionDate) {
          <tr>
            <td>-</td>
            <td class="th">
              Von
            </td>
            <td>
              @if (!aktion.GueltigVon) {
                <span>-</span>
              }
              @if (aktion.GueltigVon) {
                <span>{{ aktion.GueltigVon }}</span>
              }
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="th">
              Bis
            </td>
            <td>
              @if (!aktion.GueltigBis) {
                <span>-</span>
              }
              @if (aktion.GueltigBis) {
                <span>{{ aktion.GueltigBis }}</span>
              }
            </td>
          </tr>
        }
        @if (aktion.AbMenge) {
          <tr>
            <td></td>
            <td class="th">
              Ab Menge
            </td>
            <td class="action-quantity-cell">
              <span>{{ aktion.AbMenge }}</span>
              @if (actions) {
                <button mat-icon-button class="action-quantity-button" (click)="selectMenge(aktion)" matTooltip="Menge übernehmen">
                  <svg-icon>eingang-rechnung</svg-icon>
                </button>
              }
              @if (directAddToWarenkorb) {
                <button mat-icon-button class="action-quantity-button" (click)="addMengeDirektInWarenkorb(aktion, $event)"
                  matTooltip="Ab Menge direkt in den Warenkorb" aria-label="Ab Menge direkt in den Warenkorb">
                  <svg-icon>in-warenkorb</svg-icon>
                </button>
              }
            </td>
          </tr>
        }
        @if (aktion.Draufgabemenge) {
          <tr>
            <td></td>
            <td class="th">
              Draufgabemenge
            </td>
            <td>
              <span>{{ aktion.Draufgabemenge }}</span>
              @if (aktion.Draufgabeartikel) {
                <span> - {{ aktion.Draufgabeartikel.ArtikelName }}</span> <article-dtp-icon [isDtp]="aktion.Draufgabeartikel.IstDtpArtikel"></article-dtp-icon>
              }
            </td>
          </tr>
        }
        @if (aktion.AktionsrabattProzentsatz) {
          <tr>
            <td></td>
            <td class="th">
              Aktionsprozentsatz
            </td>
            <td>
              <span>{{ aktion.AktionsrabattProzentsatz }} %</span>
            </td>
          </tr>
        }
        @if (aktion.AktionsKundeneinkaufspreis) {
          <tr class="noborderbottom">
            <td></td>
            <td class="th">
              Aktionspreis
            </td>
            <td>
              <span>{{ aktion.AktionsKundeneinkaufspreis }} &euro;</span>
              <feature-block [features]="['ShopAktionenDurchrechnen']">
                @if (!aktion.AktionsKundeneinkaufspreis) {
                  <span>
                    @if (aktion.Draufgabemenge) {
                      <span>
                        {{ ((aktionen?.artikel.PreisLtPreiscodeMitPotentiellAufschlag * aktion.AbMenge) / (aktion.AbMenge + aktion.Draufgabemenge))|NiceNumber }}
                        &euro;<br>(durchgerechnet)
                      </span>
                    }
                    @if (aktion.AktionsrabattProzentsatz) {
                      <span>
                        {{ (aktionen?.artikel.PreisLtPreiscodeMitPotentiellAufschlag * (1 - (aktion.AktionsrabattProzentsatz / 100)))|NiceNumber }}
                        &euro;<br>(durchgerechnet)
                      </span>
                    }
                  </span>
                }
              </feature-block>
            </td>
          </tr>
        }
        <tr class="nobordertop noborderbottom">
          <td colspan="3">&nbsp;</td>
        </tr>
      </tbody>
    }
  </table>
}


@if (!(msvc.isMobile()|async)) {
  <table class="table table-striped" style="width: 100%">
    <thead>
      <tr>
        @if (showActionDate) {
          <th class="text-center">
            Von
          </th>
          <th class="text-center">
            Bis
          </th>
        }
        <th class="text-right">
          Ab Menge
        </th>
        <th class="text-center">

        </th>
        <th class="text-center">
          Draufgabemenge
        </th>
        <th class="text-center">
          Aktionsprozentsatz
        </th>
        <th class="text-center">
          Aktionspreis
        </th>
      </tr>
    </thead>
    @for (aktion of aktionen?.aktionen; track aktion) {
      <tr>
        @if (showActionDate) {
          <td class="text-center">
            @if (!aktion.GueltigVon) {
              <span>-</span>
            }
            @if (aktion.GueltigVon) {
              <span>{{ aktion.GueltigVon }}</span>
            }
          </td>
          <td class="text-center">
            @if (!aktion.GueltigBis) {
              <span>-</span>
            }
            @if (aktion.GueltigBis) {
              <span>{{ aktion.GueltigBis }}</span>
            }
          </td>
        }
        <td class="text-right action-quantity-cell">
          @if (aktion.AbMenge) {
            <span>{{ aktion.AbMenge }}</span>
          }

        </td>
        <td class="">
          @if (actions) {
            <button mat-icon-button class="action-quantity-button" (click)="selectMenge(aktion)" matTooltip="Menge übernehmen">
              <svg-icon>eingang-rechnung</svg-icon>
            </button>
          }
          @if (aktion.AbMenge && directAddToWarenkorb) {
            <button mat-icon-button class="action-quantity-button" (click)="addMengeDirektInWarenkorb(aktion, $event)"
                    matTooltip="Ab Menge direkt in den Warenkorb" aria-label="Ab Menge direkt in den Warenkorb">
              <svg-icon>in-warenkorb</svg-icon>
            </button>
          }
        </td>
        <td class="text-center">
          @if (aktion.Draufgabemenge) {
            <span>{{ aktion.Draufgabemenge }}</span>
          }
          @if (aktion.Draufgabeartikel) {
            <span> - {{ aktion.Draufgabeartikel.ArtikelName }}</span> <article-dtp-icon [isDtp]="aktion.Draufgabeartikel.IstDtpArtikel"></article-dtp-icon>
          }
        </td>
        <td class="text-center">
          @if (aktion.AktionsrabattProzentsatz) {
            <span>{{ aktion.AktionsrabattProzentsatz }} %</span>
          }
        </td>
        <td class="text-center">
          @if (aktion.AktionsKundeneinkaufspreis) {
            <span>{{ aktion.AktionsKundeneinkaufspreis }} &euro;</span>
          }
          <feature-block [features]="['ShopAktionenDurchrechnen']">
            @if (!aktion.AktionsKundeneinkaufspreis) {
              <span>
                @if (aktion.Draufgabemenge) {
                  <span>
                    {{ ((aktionen?.artikel.PreisLtPreiscodeMitPotentiellAufschlag * aktion.AbMenge) / (aktion.AbMenge + aktion.Draufgabemenge))|NiceNumber }}
                    &euro;@if (!noWrap) {<br>} (durchgerechnet)
                  </span>
                }
                @if (aktion.AktionsrabattProzentsatz) {
                  <span>
                    {{ (aktionen?.artikel.PreisLtPreiscodeMitPotentiellAufschlag * (1 - (aktion.AktionsrabattProzentsatz / 100)))|NiceNumber }}
                    &euro;@if (!noWrap) {<br>} (durchgerechnet)
                  </span>
                }
              </span>
            }
          </feature-block>
        </td>
      </tr>
    }
  </table>
}
